mutation DeletePlatformCustomCovers($ids: [ID!]!) {
  deletePlatformCustomCovers(ids: $ids) {
    id
  }
}

